import { render, staticRenderFns } from "./applicantInfo.vue?vue&type=template&id=577330fb&scoped=true"
import script from "./applicantInfo.vue?vue&type=script&lang=js"
export * from "./applicantInfo.vue?vue&type=script&lang=js"
import style0 from "./applicantInfo.vue?vue&type=style&index=0&id=577330fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577330fb",
  null
  
)

export default component.exports